/** Registration statuses that are staff / non-paying — hide Pay on admin list. */
export const NON_PAYING_REGISTRATION_STATUSES = new Set([
  'instructor',
  'volunteer',
  'camp_leader',
  'photographer',
  'blogger',
  'cancelled',
  'rejected',
  'rusticated'
]);

export function registrationRowStatus(row) {
  return String(row?.registration?.status ?? row?.status ?? '')
    .trim()
    .toLowerCase();
}

export function isNonPayingRegistration(row) {
  return NON_PAYING_REGISTRATION_STATUSES.has(registrationRowStatus(row));
}

export function bookingAmountPaid(row) {
  return Number(row?.amountPaidAtOffice ?? 0) + Number(row?.amountPaidOnline ?? 0);
}

export function bookingPendingAmount(row) {
  const total = Number(row?.totalAmount ?? 0);
  return Math.max(0, total - bookingAmountPaid(row));
}

/** No balance left on the booking — hide/disable manual Pay. */
export function isBookingFullyPaid(row) {
  const total = Number(row?.totalAmount ?? 0);
  if (total <= 0) return true;
  return bookingPendingAmount(row) <= 0;
}
